<template>
	<div>
		<button type="button" class="btn btn-primary mb-2" :disabled="disabled" @click="showModal">
			{{ showTitle }}
		</button>

		<b-modal id="modal-confirm-submit" ref="modal-confirm-submit" :title="modalTitle">
			<div class="d-block text-center">
				<h4>{{ modalText }}</h4>
			</div>

			<template #modal-footer>
				<button
					v-b-modal.modal-close_visit
					type="button"
					class="btn btn-secondary btn-md m-1"
					@click="hideModal"
				>
					{{ cancelTitle }}
				</button>
				<button
					v-b-modal.modal-close_visit
					type="submit"
					class="btn btn-primary btn-md m-1"
					:form="form"
					@click="hideModal"
				>
					{{ okTitle }}
				</button>
			</template>
		</b-modal>
	</div>
</template>

<script>
export default {
	props: {
		form: { type: String, required: true },
		modalText: { type: String, required: true },
		modalTitle: { type: String, default: 'Подтвердите действие' },
		disabled: { type: Boolean, default: false },
		showTitle: { type: String, required: true },
		okTitle: { type: String, default: 'Да' },
		cancelTitle: { type: String, default: 'Отмена' },
	},
	methods: {
		showModal() {
			if (!document.querySelectorAll(`#${this.form} .formulate-input-error`).length) {
				this.$refs['modal-confirm-submit'].show();
			}
		},
		hideModal() {
			this.$refs['modal-confirm-submit'].hide();
		},
	},
};
</script>
